export const API_URL = "https://get.ercdecoder.com/";
export const APP_VERSION = "v1.0";